import {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import {buildErrors, selectContextEntityWithState, SEVERITYSIDEPANEL} from '../../../state/slices/CoreEntity';
import * as c from "../../../constants";
// Assuming a utility function exists to add severity info

const isSeverityGreater = (s1, s2) => {
    const severityOrder = [SEVERITYSIDEPANEL.INFO, SEVERITYSIDEPANEL.LOW, SEVERITYSIDEPANEL.WARNING, SEVERITYSIDEPANEL.CRITICAL, SEVERITYSIDEPANEL.WORLD_IS_ON_FIRE];
    return severityOrder.indexOf(s1) > severityOrder.indexOf(s2);
};

export const useEntitiesWithSeverity = () => {
    const [entitiesWithSeverity, setEntitiesWithSeverity] = useState({});
    const entities = useSelector((state) => selectContextEntityWithState(state), (one, two) => JSON.stringify(one) === JSON.stringify(two));

    useEffect(() => {
        if (!entities) return;

        const enhancedEntities = enhanceWithSeverity(entities);
        setEntitiesWithSeverity(enhancedEntities);
    }, [entities]);


    const determineSeverityInfo = (entity) => {
        let errorCount = 0;
        let highestSeverity = SEVERITYSIDEPANEL.INFO; // Default to INFO severity
        let errors = [];

        if (!entity) {
            return null
        }

        // Only process errors if the typeId is equal to 3
        if (entity?.typeid === 3 || entity?.typeid === c.ENTITY_TYPE.Area) {
            errors = buildErrors(entity);
            errorCount = entity.typeid === c.ENTITY_TYPE.Device ? errors.length : errors.length - 1;

            errors.forEach(error => {
                if (isSeverityGreater(error.Severity, highestSeverity)) {
                    highestSeverity = error.Severity;
                }
            });
        }


        if (entity?.children) {
            entity.children.forEach(child => {
                const childData = determineSeverityInfo(child);
                errorCount += childData.errorCount;
                if (isSeverityGreater(childData.highestSeverity, highestSeverity)) {
                    highestSeverity = childData.highestSeverity;
                }
            });
        }
        return {
            errorCount: errorCount < 0 ? 0 : errorCount,
            highestSeverity,
            errors: errors,
            entityname: entity.name
        };
    }

    const enhanceWithSeverity = (entity) => {
        let flatEntities = {};
        const traverseAndUpdate = (node) => {
            if (!node) return null;

            const severityInfo = determineSeverityInfo(node);

            const updatedNode = {...node, SeverityInfo: severityInfo};

            flatEntities[node.entityid] = updatedNode;// flattening the tree just for easier indexing later

            if (!updatedNode.children || updatedNode.children.length === 0) {
                return updatedNode;
            }

            const updatedChildren = updatedNode.children.map(child => traverseAndUpdate(child));

            return {...updatedNode, children: updatedChildren};
        };

        traverseAndUpdate(entity);
        return flatEntities;
    };

    return {
        entitiesWithSeverity
    };
};